
<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="6">
        <b-card>
          <div slot="header">
            <strong>{{headerTitle}}</strong>
          </div>
          <b-form>
          <b-form-group
            v-if="this.userData.key == null"
            label="User role"
            label-for="roleSelect"
            :label-cols="3"
            :horizontal="true">
            <b-form-select id="roleSelect"
              :plain="true"
              :options="[
                {text: 'Select user role...',value: 'none'},
                {text: 'Coach',value: 'coach'},
                {text: 'Parent',value: 'parent'},
                {text: 'Player',value: 'player'}
              ]"
              value="none"
              v-model="userData.role"
              v-on:change="showRoleForm">
            </b-form-select>
          </b-form-group>
          <b-form id="commonForm" v-if="showCommonForm">
            <b-form-group validated
            label="Name"
            label-for="userName"
            :label-cols="3"
            :horizontal="true">
            <b-form-input id="userName" type="text" required autocomplete="name" v-model="userData.name"></b-form-input>
          </b-form-group>
          <b-form-group validated
            label="Last Name"
            label-for="userLastName"
            :label-cols="3"
            :horizontal="true">
            <b-form-input id="userLastName" type="text" required autocomplete="lastName" v-model="userData.lastName"></b-form-input>
          </b-form-group>
          <b-form-group
            label="Gender"
            label-for="genderRadio"
            :label-cols="3"
            :horizontal="true">
            <b-form-radio-group 
              id="genderRadio"
              :plain="true"
              :options="[
                {text: 'Male',value: 'male'},
                {text: 'Female',value: 'female'}
              ]"
              :checked="1"
              v-model="userData.gender">
            </b-form-radio-group>
          </b-form-group>
          <b-form-group validated
              label="Country"
              label-for="countrySelect"
              :label-cols="3"
              :horizontal="true">
              <country-select style="width:100%; height:100%" v-model="userData.country" :country="userData.country" topCountry="US" />
          </b-form-group>
          <b-form-group validated
            label="Birthdate" label-for="birthdate"
            :label-cols="3"
            :horizontal="true">
            <b-form-input type="date" required id="birthdate" 
            v-model="userData.birthdate"></b-form-input>
          </b-form-group>
          <b-form-group
            label="Profile picture"
            label-for="userPicture"
            :label-cols="3"
            :horizontal="true">
              <b-form-file 
              accept="image/*" id="userPicture" :plain="true" v-model="userData.pictureFile"></b-form-file>
          </b-form-group>
          <b-form-group validated v-if="!showPlayerForm"
            label="Email"
            label-for="userName"
            :label-cols="3"
            :horizontal="true">
            <b-form-input id="userName" type="email" required autocomplete="email" v-model="userData.email"></b-form-input>
          </b-form-group>
          </b-form>
          <b-form id="playerForm" v-if="showPlayerForm">
            <b-form-group validated
              label="Position"
              label-for="positionSelect"
              :label-cols="3"
              :horizontal="true">
              <b-form-select id="positionSelect"
                :plain="true"
                :options="['Select position...','Goalkeeper', 'Defender', 'Midfielder', 'Striker']"
                value="Select position..."
                v-model="playerData.position"
                required>
              </b-form-select>
            </b-form-group>
            <b-form-group>
            <b-form-group v-if="!isEdit"
              label="Parent"
              :label-cols="3"
              :horizontal="true">
              <vue-bootstrap-typeahead
              placeholder="Search parent..."
              v-model="parentName"
              :data="parentsArray"
              :serializer="s => s.val().name + ' ' + s.val().lastName"
              @hit="setTutorData($event)"/>
            </b-form-group>
            
          </b-form-group>
          </b-form>
          <b-form-group>
            <b-alert variant="danger"
                     dismissible
                     :show="showDismissibleAlert"
                     @dismissed="showDismissibleAlert=false">
                     {{ dismissibleAlertText }}
            </b-alert>
            </b-form-group>
          <div slot="footer">
            <b-row class="align-items-center">
              <!-- <b-col xl= "2" class="mb-3 mb-xl-0" >
                <b-button v-on:click="sendWelcomeMail" block variant="secondary">Send mail</b-button>
              </b-col> -->
              <b-col xl= "2" class="mb-3 mb-xl-0" >
                <b-button v-on:click="goBack" block variant="secondary">Back</b-button>
              </b-col>
              <b-col xl= "6" class="mb-3 mb-xl-0" >
                <b-button type="submit" v-if="!isEdit" v-on:click="confirmUserButton" block variant="primary"><i class="fa fa-dot-circle-o"></i> Confirm User</b-button>
                <b-button type="submit"  v-if="isEdit" v-on:click="updateUser" block variant="primary"><i class="fa fa-dot-circle-o"></i> Save Changes</b-button>
              </b-col>
              <b-col xl= "4" class="mb-3 mb-xl-0" >
                <b-alert variant="danger"
                        :show="!checkIfRemovable() && isEdit && userData.role != null">
                        This user can't be removed while on a Team
                </b-alert>
                <b-button v-if="checkIfRemovable()" v-on:click="removeUser" block variant="danger"><i class="fa fa-ban"></i> Remove User</b-button>
              </b-col>
            </b-row>
          </div>
          </b-form>
        </b-card>
        <b-row>
          <b-col md="6">
            <b-card v-if="isEdit">
              <div slot="header">
                <strong>Picture image</strong>
              </div>
              <b-form-group v-if="previewImageUrl != null" >
                <b-img v-bind:src="previewImageUrl" fluid alt="Responsive image" />
              </b-form-group>
            </b-card>
          </b-col>
          <b-col md="6">
            <b-card v-if="userData.pictureFile != null">
              <div slot="header">
                <strong>New Picture image</strong>
              </div>
              <b-form-group  >
                <b-img v-bind:src="getPictureFileImage()" fluid alt="Responsive image" />
              </b-form-group>
            </b-card>
          </b-col>
        </b-row>
      </b-col>
      <b-col md="6" >
        <b-row v-if="playerData.tutor != null" >
          <b-card >
          <div slot="header">
            <strong>Tutor information</strong>
          </div>
          <b-form id="playerTutorForm" >
            <b-form-group validated
            label="Name"
            label-for="userName"
            :label-cols="3"
            :horizontal="true">
            <b-form-input :readonly=true id="tutorName" type="text" required autocomplete="name" v-model="tutorData.name"></b-form-input>
          </b-form-group>
          <b-form-group validated
            label="Last Name"
            label-for="userLastName"
            :label-cols="3"
            :horizontal="true">
            <b-form-input :readonly=true id="userLastName" type="text" required autocomplete="lastName" v-model="tutorData.lastName"></b-form-input>
          </b-form-group>
          <b-form-group validated
            label="Birthdate" label-for="birthdate"
            :label-cols="3"
            :horizontal="true">
            <b-form-input :readonly=true type="date" required id="birthdate" 
            v-model="tutorData.birthdate"></b-form-input>
          </b-form-group>
          <b-form-group validated
            label="Email"
            label-for="userName"
            :label-cols="3"
            :horizontal="true">
            <b-form-input :readonly=true id="userName" type="email" required autocomplete="email" v-model="tutorData.email"></b-form-input>
          </b-form-group>
          </b-form>
        </b-card>
        </b-row>
        <b-row v-if="playerData.tutor != null">
          <b-card v-if="previewTutorImageUrl != null">
          <div slot="header">
            <strong>Tutor picture image</strong>
          </div>
          <b-form-group>
            <b-img v-bind:src="previewTutorImageUrl" fluid alt="Responsive image" />
          </b-form-group>
        </b-card>
        </b-row>
        
        <b-row v-if="teamsArray.length > 0">
            <transition name="slide">
            <b-card :header="caption">
              <b-table :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="teamsArray" :fields="fieldsTeams" :current-page="currentPage" :per-page="perPage" @row-clicked="teamClicked">
                <template slot="name" slot-scope="data">
                  <strong>{{data.item[1].name}}</strong>
                </template>
                <template slot="category" slot-scope="data">
                  <strong>{{getCategoryName(data.item[1].category)}}</strong>
                </template>
              </b-table>
              <nav>
                <b-pagination size="sm" :total-rows="teamsArray.length" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>            
              </nav>
            </b-card>
            </transition>
        </b-row>

        <b-row v-if="childrenArray.length > 0">
            <transition name="slide">
            <b-card :header="caption">
              <b-table :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="childrenArray" :fields="fieldsChildren" :current-page="currentPage" :per-page="perPage" @row-clicked="childClicked">
                <template slot="name" slot-scope="data">
                  <strong>{{data.item[1].name}}</strong>
                </template>
                <template slot="lastName" slot-scope="data">
                  {{data.item[1].lastName}}
                </template>
                <template slot="email" slot-scope="data">
                  {{data.item[1].email}}
                </template>
                <template slot="status" slot-scope="data">
                  {{data.item[1].status}}
                </template>
              </b-table>
              <nav>
                <b-pagination size="sm" :total-rows="childrenArray.length" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>            
              </nav>
            </b-card>
            </transition>
        </b-row>

      </b-col>


    </b-row>
    
  </div>
</template>

<script>
import _ from 'underscore'
import { db } from '@/config/devowqlo';
import { storage } from '@/config/devowqlo';
import { auth } from '@/config/devowqlo';
import { functions } from '@/config/devowqlo';
export default {
  name: 'forms',
  firebase: {
    users: db.ref('users'),
    parents: db.ref('users').child('parents'),
    counts: db.ref('counts'),
    teams: db.ref('teams'),
    categories: db.ref('categories')
  },
  props: {
    caption: {
      type: String,
      default: 'Teams'
    },
    hover: {
      type: Boolean,
      default: true
    },
    striped: {
      type: Boolean,
      default: true
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      headerTitle: 'Add user',
      isEdit: false,
      showDismissibleAlert: false,
      dismissibleAlertText: '',
      showCommonForm: false,
      showPlayerForm: false,
      userData: {
          key: null,
          role: null,
          name: null,
          lastName: null,
          gender: null,
          country: null,
          birthdate: null,
          pictureFile: null,
          pictureUrl: null,
          thumbPictureUrl: null,
          email: null,
          teamKey: null,
          team: null
      },
      playerData: {
          position: null,
          tutor: null,
          tutorKey: null
      },
      tutorData: {
        name: null,
        lastName: null,
        birthdate: null,
        email: null,
        thumbPictureUrl: null,
      },
      parentName: null,
      parentsArray: [],
      previewImage: null,
      previewImageUrl: null,
      previewTutorImageUrl: null,
      teamsArray: [],
      fieldsTeams: [
        {key: 'name'},
        {key: 'category'}
      ],
      childrenArray: [],
      fieldsChildren: [
        {key: 'name'},
        {key: 'lastName'},
        {key: 'email'},
        {key: 'status'}
      ],
      currentPage: 1,
      perPage: 5,
      totalRows: 0,
    
      propertyList: []
    }
  },
  
  created() {
    console.log("info", this.$route.params.info)
    if(this.$route.params.info){
      const infoString = String(this.$route.params.info)
      const infoSplit = infoString.split('&&')
      this.userData.key = infoSplit[0]
      this.userData.role = infoSplit[1]
      this.showRoleForm(infoSplit[1])
      this.setUser()
    }
  },

  methods: {
    sendWelcomeMail(){

       //Created user
      auth.sendPasswordResetEmail(this.userData.email).then(function() {
        // Email sent.
      }).catch(function(error) {
        // An error happened.
      });

      var sendWelcomeMailFunc = functions.httpsCallable('sendWelcomeMail');
      sendWelcomeMailFunc({email: this.userData.email}).then((result) => {
        console.log(result)

      })
    },

    setTutorData(tutor){
      console.log(tutor)
      this.tutorData.name = tutor.val().name
      this.tutorData.lastName = tutor.val().lastName
      this.tutorData.birthdate = tutor.val().birthdate
      this.tutorData.email = tutor.val().email

      this.playerData.tutor = tutor
    },

    checkIfRemovable(){
      if(this.isEdit){
        if(this.userData.role == "player" && this.teamsArray.length == 0){
          return true
        }
        if(this.userData.role == "coach" && this.teamsArray.length == 0){
          return true
        }
        if(this.userData.role == "parent" && this.childrenArray.length == 0){
          return true
        }
      }
      return false
    },
    removeUser(){



      // //---Remove user node

      // //Remove storage files
      // var pictureRef = storage.ref().child("UserPictures").child(this.userData.pictureUrl)
      // var thumbpictureRef = storage.ref().child("UserPictures").child(this.userData.thumbPictureUrl)

      // // Delete the file
      // pictureRef.delete().then(function() {
      //   // File deleted successfully
      // }).catch(function(error) {
      //   // Uh-oh, an error occurred!
      // });

      // // Delete the file
      // thumbpictureRef.delete().then(function() {
      //   // File deleted successfully
      // }).catch(function(error) {
      //   // Uh-oh, an error occurred!
      // });

      // this.$firebaseRefs.news.child(this.newsData.key).remove()

      // var countRef = this.$firebaseRefs.counts.child('userCounts').child('count')

      // countRef.transaction(function(count) {
      //   if (count) {
      //     if(count > 0){
      //       count = count - 1;
      //     }
      //   }else{
      //     count = 0
      //   }
      //   return count;
      // })

      this.$router.go(-1)
    },
    updateUser(){
      // if(this.newsData.mediaFile != null){
        
      // }
    },
    goBack() {
      this.$router.go(-1)
      // this.$router.replace({path: '/users'})
    },
    checkForm(){

      console.log(this.userData)
      console.log(this.playerData)
      if(this.userData.name && this.userData.lastName && this.userData.gender
      && this.userData.country && this.userData.birthdate && this.userData.pictureFile){
        if(this.userData.role == "player"){
          if(this.playerData.position && this.playerData.tutor){
            return true
          }
        }
        else{
          if(this.userData.email){
            return true
          }
        }
      }
      return false
    },
    confirmUserButton () {

      this.showDismissibleAlert = false
      this.dismissibleAlertText = ''

      if(this.checkForm() == true){
        console.log("Form checked")
        this.addUser()
      }
      else
      {
        this.showDismissibleAlert = true
        this.dismissibleAlertText = 'Missing data fields'
      }

      
    },
    parentNameChanged(value) {
      console.log("tutor", this.playerData.tutor)
      console.log("value", value)
      if(this.playerData.tutor != null){
       if(this.playerData.tutor.val().name + ' ' + this.playerData.tutor.val().lastName != value){
         console.log("nulled tutor")
         this.playerData.tutor = null
       }
      }
      console.log("tutor", this.playerData.tutor)
      this.parentsArray = []
      var filteredArray = []
      this.$firebaseRefs.users.child('parents').
          orderByChild("name").
          startAt(this.parentName.toUppercase).
          endAt(this.parentName.toLowerCase+"\uf8ff").
          limitToFirst(100).
          once('value', function(snap) {

              snap.forEach(function (childSnapshot) {

                var value = childSnapshot.val();
                filteredArray.push(childSnapshot)
              });
          });
          this.parentsArray = filteredArray

    },
    showRoleForm(value){
      if(value == "coach" || value == "parent"){
        console.log("Coach or parent selected")
        this.showPlayerForm = false
        this.showCommonForm = true
      }else if(value == "player"){
        console.log("Player selected")
        this.showPlayerForm = true
        this.showCommonForm = true
      }else{
        console.log("None selected")
        this.showPlayerForm = false
        this.showCommonForm = false
      }
    },
    getPictureFileImage(){
        console.log(this.userData.pictureFile)
        var reader = new FileReader()
        reader.onload = (e) => {
          this.previewImage = e.target.result
        }
        reader.readAsDataURL(this.userData.pictureFile)

        return this.previewImage
    },
    setUser(){
      this.headerTitle = 'Edit user'
      this.isEdit = true
      var userGroup = ''
      if(this.userData.role == "coach"){
        userGroup = this.userData.role + 'es/'
      }else{
        userGroup = this.userData.role + 's/'
      }
      
      this.teamsArray = []
      this.childrenArray = []
      db.ref('users/' + userGroup).child(this.userData.key).on('value',(snap) => {
        //var snap = snapshot.child(this.userData.key)
        if(snap){
          console.log(snap.val())
          this.userData.name = snap.val().name
          this.userData.lastName = snap.val().lastName
          this.userData.gender = snap.val().gender
          this.userData.country = snap.val().country
          this.userData.birthdate = snap.val().birthdate
          this.userData.pictureUrl = snap.val().pictureUrl
          this.userData.thumbPictureUrl = snap.val().thumbPictureUrl

          if(this.userData.role == "player"){
            this.playerData.position = snap.val().position

            console.log(snap.val().tutor)
            this.playerData.tutorKey = Object.keys(snap.val().tutor)[0]
            var tutorValues = Object.values(snap.val().tutor)[0]
            console.log(tutorValues)
            this.tutorData.name = tutorValues.name
            this.tutorData.lastName = tutorValues.lastName
            this.tutorData.birthdate = tutorValues.birthdate
            this.tutorData.email = tutorValues.email

            this.playerData.tutor = Object.values(snap.val().tutor)[0]
            // this.playerData.tutor = snap.val().tutor
            // console.log(this.playerData.tutor)
            storage.ref().child("UserPictures").child(tutorValues.thumbPictureUrl).getDownloadURL().then((url) => {

              this.previewTutorImageUrl = url
            }).catch(function(error) {
              // Handle any errors
            });

          }else{
            this.userData.email = snap.val().email
          }

          if(snap.val().teams != null){
            console.log(Object.entries(snap.val().teams))
            var userTeams = []
            userTeams.push(Object.entries(snap.val().teams))

            this.teamsArray = userTeams[0]
            console.log(this.teamsArray)
            
          }

          if(snap.val().children != null){
            console.log(Object.entries(snap.val().children))
            var userChildren = []
            userChildren.push(Object.entries(snap.val().children))

            this.childrenArray = userChildren[0]
            console.log(this.childrenArray)
            
          }

          storage.ref().child("UserPictures").child(this.userData.thumbPictureUrl).getDownloadURL().then((url) => {

          this.previewImageUrl = url
          }).catch(function(error) {
            // Handle any errors
          });
        }
        
        

      });

      
      
      
    }, 
    getCategoryName(categoryId){
      var categoryName = ''
      this.categories.forEach(element => {
       if(element['.key'] == categoryId){
         categoryName = element.name
       }
      });
      return categoryName
    },
    teamClicked (team) {
      
      const teamLink = `/teams/` + team[0]
      this.$router.push({path: teamLink})
      // :to="{ name: 'Edit', params: {id: item['.key']} }"
    },
    childClicked (child) {
      
      const childLink = `/users/` + child[0] + '&&' + 'player'
      //this.$router.go(-1)
      this.$router.push({path: childLink})
      //this.$router.go({path: childLink})
      // :to="{ name: 'Edit', params: {id: item['.key']} }"
    },
    addUser(){

      if(this.userData.role == "player"){
        this.userData.email = this.userData.name + this.userData.lastName + "_placeholder" + "@owqlotest.com"
      }

      var createUserAndSetRole = functions.httpsCallable('createUserAndSetRole');
      createUserAndSetRole({email: this.userData.email, role: this.userData.role}).then((result) => {
        console.log(result)
        if(result.data.errorInfo){

          //Error creating user
          this.dismissibleAlertText = result.data.errorInfo.message
          this.showDismissibleAlert = true
        }else{

          //Created user
          // auth.sendPasswordResetEmail(this.userData.email).then(function() {
          //   // Email sent.

          // }).catch(function(error) {
          //   // An error happened.
          // });


          this.uploadPictureFile(result.data.uid)
        }

      })
      
    },
    uploadPictureFile(uid){

      console.log("Uploading picture...")
      const pictureName = (+new Date()) + '-' + this.userData.pictureFile.name;
      const pictureMetadata = { contentType: this.userData.pictureFile.type };
      const uploadTask = storage.ref().child("UserPictures").child(pictureName).put(this.userData.pictureFile, pictureMetadata)
        .then(snapshot => snapshot.ref.getDownloadURL())
        .then(url => this.createUserDb(pictureName, uid))
    },
    createUserDb(pictureName, uid){
      
      //console.log(uid)
      console.log("Creating user on DB...")
      var userGroup = ''
      if(this.userData.role == "coach"){
        userGroup = this.userData.role + 'es/'
      }else{
        userGroup = this.userData.role + 's/'
      }
       
      const thumbPictureUrl = 'thumb_' + pictureName
      const dateNow = Date.now()

      if(this.userData.role == "player"){
        //TO DO
        var tutorVal = this.playerData.tutor.val()
        var playerEmail = this.userData.name + this.userData.lastName + "_placeholder" + "@owqlotest.com"


        var tutorModel = { 
          name: tutorVal.name,
          lastName: tutorVal.lastName,
          birthdate: tutorVal.birthdate,
          pictureUrl: tutorVal.pictureUrl,
          thumbPictureUrl: tutorVal.thumbPictureUrl,
          email: tutorVal.email,
        }

        var childModel = { 
          name: this.userData.name,
          lastName: this.userData.lastName,
          birthdate: this.userData.birthdate,
          pictureUrl: pictureName,
          thumbPictureUrl: thumbPictureUrl,
          email: this.userData.email,
        }

        var playerModel = { 
          name: this.userData.name,
          lastName: this.userData.lastName,
          gender: this.userData.gender,
          country: this.userData.country,
          birthdate: this.userData.birthdate,
          pictureUrl: pictureName,
          thumbPictureUrl: thumbPictureUrl,
          role: this.userData.role,
          email: this.userData.email,
          position: this.playerData.position,
          created: dateNow,
          modified: dateNow
        }

        var tutorKey = this.playerData.tutor.key

        //Create player 
        this.$firebaseRefs.users.child(userGroup).child(uid).set(playerModel)

        //Create player tutor
        this.$firebaseRefs.users.child(userGroup).child(uid).child('tutor').child(tutorKey).set(tutorModel)

        //Create parent child
        this.$firebaseRefs.users.child('parents').child(tutorKey).child('children').child(uid).set(childModel)
        

        var countRef = this.$firebaseRefs.counts.child('playersCount').child('count')
        countRef.transaction(function(count) {
            if (count) {
              count = count + 1;
            }else{
              count = 1
            }
            console.log(count)
            return count;
        });

      }else if(this.userData.role == "coach"){
        
        this.$firebaseRefs.users.child(userGroup).child(uid).set({
            name: this.userData.name,
            lastName: this.userData.lastName,
            gender: this.userData.gender,
            country: this.userData.country,
            birthdate: this.userData.birthdate,
            pictureUrl: pictureName,
            thumbPictureUrl: thumbPictureUrl,
            role: this.userData.role,
            email: this.userData.email,
            created: dateNow,
            modified: dateNow
        })

        var countRef = this.$firebaseRefs.counts.child('coachesCount').child('count')
        countRef.transaction(function(count) {
            if (count) {
              count = count + 1;
            }else{
              count = 1
            }
            console.log(count)
            return count;
        });

      }else if(this.userData.role == "parent"){
        this.$firebaseRefs.users.child(userGroup).child(uid).set({
            name: this.userData.name,
            lastName: this.userData.lastName,
            gender: this.userData.gender,
            country: this.userData.country,
            birthdate: this.userData.birthdate,
            pictureUrl: pictureName,
            thumbPictureUrl: thumbPictureUrl,
            role: this.userData.role,
            email: this.userData.email,
            created: dateNow,
            modified: dateNow
        })

        var countRef = this.$firebaseRefs.counts.child('parentsCount').child('count')
        countRef.transaction(function(count) {
            if (count) {
              count = count + 1;
            }else{
              count = 1
            }
            console.log(count)
            return count;
        });
      }

      var countRef = this.$firebaseRefs.counts.child('usersCount').child('count')
      countRef.transaction(function(count) {
          if (count) {
            count = count + 1;
          }else{
            count = 1
          }
          console.log(count)
          return count;
      });

      this.$router.go(-1)
    }

  },
  watch: {
    parentName: _.debounce(function(par) { this.parentNameChanged(par) }, 500),
    '$route.params.info' (to, from) {
      // react to route changes...
      console.log("watched route")
      if(this.$route.params.info){
        const infoString = String(this.$route.params.info)
        const infoSplit = infoString.split('&&')
        this.userData.key = infoSplit[0]
        this.userData.role = infoSplit[1]
        this.showRoleForm(infoSplit[1])
        this.setUser()
      }
    }
  }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>



// getAge(birthdate) {
    //   var today = new Date();
    //   var birthDate = new Date(birthdate);
    //   var age = today.getFullYear() - birthDate.getFullYear();
    //   var m = today.getMonth() - birthDate.getMonth();
    //   if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    //       age--;
    //   }    
    //   return age;
    // }
    // console.log(this.userData.birthdate)
      // const timestamp = new Date(this.userData.birthdate).getTime()
      // console.log(timestamp)
      // const dateFromTimestamp = new Date(timestamp)
      // console.log(dateFromTimestamp)

      // if(this.$route.params.teamid != null){
      //   console.log(this.$route.params.teamid)
      // }else{
      //   console.log("No hay id equipo")
      // }

      // Get a key for a new User.
      // var userDataKey = this.$firebaseRefs.users.push().key;

      // this.$firebaseRefs.users.child(userDataKey).set({
      //    name: this.userName,
      //    category: this.categorySelect
      // })

      // this.$firebaseRefs.users.child().set({
      //   name: this.userName,
      //   category: this.categorySelect
      // })